import {
  SCCButton,
  SCCContainer,
  SCCItem,
} from "../styles/ServiceChannelsStyles";

const SERVICE_CHANNEL_LINKS = [
  {
    href: "https://portal.sulamericaseguros.com.br/canaisdeatendimento/",
    label: "Canais de Atendimento",
  },
  {
    href: "https://portal.sulamericaseguros.com.br/privacidade/login",
    label: "Portal de privacidade",
  },
] as const;

export function ServiceChannelsBox() {
  return (
    <SCCContainer>
      <SCCItem container>
        {SERVICE_CHANNEL_LINKS.map(({ href, label }) => (
          <SCCItem size={12} key={label}>
            <SCCButton
              href={href}
              target="_blank"
              rel="noopener noreferrer"
            >
              {label}
            </SCCButton>
          </SCCItem>
        ))}
      </SCCItem>
    </SCCContainer>
  );
}

export default ServiceChannelsBox;